import { DatePipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ExportFormat } from '../../../../core/buttons/export-button.component';
import { TagComponent, TagType } from '../../../../core/labels/tag.component';
import { LoadingPanelComponent } from '../../../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { TableComponent } from '../../../../core/table/table.component';
import { ExportService } from '../../../../../services/export/export.service';
import { AbsenceStatusHistoryExportMapper } from '../../../../../utilities/absence-status-history-export-mapper';

@Component({
  selector: 'app-absence-status-history',
  imports: [
    LoadingPanelComponent,
    TableComponent,
    ColumnComponent,
    TagComponent,
  ],
  template: ` <app-loading-panel state="Loaded">
    <ng-template #loaded>
      <app-table
        [dataSource]="dataSource"
        [pageSize]="5"
        [recordLabel]="'History'"
        [recordLabelPlural]="'Histories'"
        [showExport]="true"
        [globalFilterFields]="[
          'statusDate',
          'activeStatus',
          'absenceStatus',
          'absenceSubStatus',
        ]"
        (export)="onExport($event)"
      >
        <app-column name="statusDate" label="Date" width="33%" format="d" />
        <app-column name="activeStatus" label="Status" width="33%">
          <ng-template #value let-data>
            <app-tag [type]="getStatusTagType(data.activeStatus)">
              {{ data.activeStatus }} - {{ data.absenceStatus }}
            </app-tag>
          </ng-template>
        </app-column>
        <app-column name="absenceSubStatus" label="Substatus" width="34%" />
      </app-table>
    </ng-template>
  </app-loading-panel>`,
  styles: [],
})
export class AbsenceStatusHistoryComponent {
  private datePipe = inject(DatePipe);
  private exportService = inject(ExportService);

  @Input()
  dataSource: any[];

  getStatusTagType(activeStatus: string | null | undefined): TagType {
    const normalized = (activeStatus || '').trim().toLowerCase();
    if (!normalized) {
      return 'Grey';
    }

    if (normalized.startsWith('open') || normalized.startsWith('reopen')) {
      return 'Success';
    }

    if (normalized.startsWith('closed')) {
      return 'Error';
    }

    if (normalized.startsWith('incident')) {
      return 'Warn';
    }

    return 'Grey';
  }

  async onExport(format: ExportFormat) {
    const formattedDate = this.datePipe.transform(new Date(), 'yyyyMMddHHmm');
    const filename = `AbsenceStatusHistory_${formattedDate}.${format}`;

    if (format === 'csv') {
      const csvData = AbsenceStatusHistoryExportMapper.toCsvExport(
        this.dataSource,
        'Absence Status History',
      );
      await this.exportService.exportCsv(csvData, filename);
    } else if (format === 'xlsx') {
      const excelData = AbsenceStatusHistoryExportMapper.toExcelExport(
        this.dataSource,
        'Absence Status History',
        'OmniInsights Export',
      );
      await this.exportService.exportExcel(excelData, filename);
    }
  }
}
